export default {"src":"/_next/static/media/AM.fe4c927f.svg","height":18,"width":18};